import { Component, Input, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as fromStoryblok from '../../store';
import { UrlUtils } from '~app/modules/generic/utils/url.utils';
import { CountryCode, FeatureToggleEnum, NEWSLETTER_PAGE_SOURCE, NUMBER_10, NUMBER_5 } from '~shared/constants';
import { VoucherType } from '~shared/models';
import { ActiveFeaturesConfigcatService } from '~shared/modules/active-features/services';
import { UserInfoState, isSubsidiary } from '~shared/modules/user-info/store';
import { getCountryDomainCode } from '~server/utils/country-detection.util';

@Component({
  selector: 'app-newsletter-wrapper',
  templateUrl: './newsletter-wrapper.component.html',
})
export class NewsletterWrapperComponent implements OnDestroy {
  @Input() source?: NEWSLETTER_PAGE_SOURCE;
  @Input() newsLetterTitle?: string;
  @Input() newsLetterVoucherType?: VoucherType;
  @Input() newsLetterAmount?: string;
  @Input() color?: string;
  @Input() isSmallSize?: boolean;
  @Input() hasSeoContent?: boolean;

  private unsubscribe$ = new Subject();

  market: string;
  isCategoryPlpRoute: boolean = UrlUtils.isCategoryPage(this.router.url);
  isBrandPlpRoute: boolean = UrlUtils.isBrandPlpPage(this.router.url);
  isSubsidiaryAccount$: Observable<boolean>;
  NLDiscount: string = NUMBER_10.toString();

  readonly LIGHT_BLUE_COLOR = 'lightBlue';

  constructor(
    private featureFlagService: ActiveFeaturesConfigcatService,
    private router: Router,
    private store: Store<fromStoryblok.StoryblokState | UserInfoState>
  ) {
    this.market = getCountryDomainCode();

    this.isSubsidiaryAccount$ = this.store.pipe(select(isSubsidiary));
    this.getNetherlandsDiscount();
    this.initializeDefaultColor();
  }

  initializeDefaultColor(): void {
    if (!this.color && (this.isCategoryPlpRoute || this.isBrandPlpRoute)) {
      this.color = this.LIGHT_BLUE_COLOR;
    }
  }

  getNetherlandsDiscount(): void {
    this.featureFlagService
      .isFeatureEnabledAndReady(FeatureToggleEnum.FF_NL_DISCOUNT_5)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((enabled) => {
        if (enabled && !this.newsLetterTitle && this.market === CountryCode.Netherlands) {
          this.newsLetterAmount = NUMBER_5.toString();
          this.NLDiscount = NUMBER_5.toString();
        }
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
